<mat-card class="mat-elevation-z3">
    <div class="action-container">
        <h2 class="table-title">
            {{
                !selection.selected.length
                    ? 'Roles'
                    : selection.selected.length === 1
                    ? '1 Role selected'
                    : selection.selected.length + ' Roles selected'
            }}
        </h2>

        <div class="search-container" color="primary">
            <app-search-bar #search (searchEvent)="applyFilter($event);" (clearSearchEvent)="clearFilter();"></app-search-bar>
        </div>
        <div class="action-buttons">
            <!-- <button mat-raised-button *ngIf="removeItems" color="warn" [disabled]="!selection.selected.length"
        (click)="deleteRoles(selection)" aria-label="Remove selected roles" matTooltip="Delete">
        <mat-icon>delete_outline</mat-icon>
        <span>Delete</span>
      </button>
      <button mat-raised-button *ngIf="!removeItems" color="primary" (click)="editRoles()" aria-label="Edit Role(s)"
        matTooltip="Edit Roles">
        <mat-icon>edit</mat-icon>
        <span>Edit Roles</span>
      </button>
      <button mat-raised-button *ngIf="removeItems" color="primary" (click)="cancelEdit()" aria-label="Cancel edit"
        matTooltip="Cancel Edit">
        <mat-icon>clear</mat-icon>
        <span>Cancel</span>
      </button> -->
            <button mat-raised-button color="primary" (click)="addRole()" aria-label="Add New Role" matTooltip="Add Roles">
                <mat-icon>add</mat-icon>
                <span>Add</span>
            </button>
        </div>
    </div>

    <div class="table-wrapper">
        <table #table mat-table [dataSource]="dataSource" matSort>
            <!-- ID Column -->
            <!-- <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 10%;">ID</th>
        <td mat-cell *matCellDef="let role">{{ role.RoleId }}</td>
      </ng-container> -->

            <!-- Label Column -->
            <ng-container matColumnDef="label">
                <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: auto">Label</th>
                <td mat-cell *matCellDef="let role">{{ role.roleName }}</td>
            </ng-container>

            <!-- Total Users Column -->
            <ng-container matColumnDef="totalusers">
                <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 100px">Total Users</th>
                <td mat-cell *matCellDef="let role">{{ role.userRole.length }}</td>
            </ng-container>

            <!-- Actions Column -->
            <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let role" style="width: 200px; text-align: right">
                    <ng-container *ngIf="role.roleName !== 'Admin' && role.roleName !== 'Contributor'">
                        <button mat-flat-button color="primary" (click)="editRole(role)">Edit</button>
                        <button mat-flat-button color="warn" (click)="deleteRole(role)">Delete</button>
                    </ng-container>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; let even = even; columns: displayedColumns" [class.evenRow]="even"></tr>

            <!-- Row shown when there is no matching data. -->
            <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" colspan="5">
                    No roles matching the filter
                    <span *ngIf="search.value"> "{{ search.value }}"</span>
                </td>
            </tr>
        </table>
    </div>
    <mat-paginator [pageSizeOptions]="[15, 25, 50, 100]"></mat-paginator>
</mat-card>
